module.exports = [
    {
        path: '/income/index',
        name: 'income.index',
        component: require('../views/income/index.vue').default
    }
];

